"use client";

import { useEffect, useRef, useState } from "react";
import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GetInTouchWithCarServiceConnecticut() {
  const parallaxRef = useRef<HTMLDivElement>(null);
  const [scrollY, setScrollY] = useState(0);
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const parallaxOffset = scrollY * 0.4;
  return <section className="relative w-full min-h-screen overflow-hidden bg-dark-background">
      {}
      <div ref={parallaxRef} className="absolute inset-0 bg-cover bg-center transition-transform duration-100 ease-linear" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1431253/img/new_york_city_skyline_night.png)",
      transform: `translateY(${parallaxOffset}px)`
    }} aria-hidden="true" />

      {}
      <div className="absolute inset-0 bg-gradient-to-b from-primary-dark/70 via-primary-dark/60 to-primary-dark/80" />

      {}
      <div className="relative z-10 flex items-center justify-center min-h-screen px-6 py-20 md:py-32">
        <div ref={headlineRef} className={`max-w-4xl mx-auto text-center transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-dark leading-tight mb-6">
            Get in Touch with Car Service Connecticut
          </h1>

          <p className="text-lg md:text-xl text-foreground-dark/90 mb-10 max-w-2xl mx-auto leading-relaxed">
            Experience premium transportation services across Connecticut, New York City, Long Island, and New Jersey. Available 24/7 for all your travel needs.
          </p>

          {}
          <Link to="/ContactPage">
            <Button size="lg" className="btn-primary group shadow-strong hover:shadow-[0_12px_40px_rgb(0_0_0_/_0.24)] transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-105 active:scale-100">
              <Phone className="size-5 transition-transform duration-[var(--duration-medium)] group-hover:rotate-12" />
              <span className="font-semibold text-base md:text-lg">
                Contact Us Now
              </span>
            </Button>
          </Link>

          {}
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4 text-foreground-dark/80">
            <Link to="tel:(203) 872-9965" className="hover:text-accent transition-colors duration-[var(--duration-fast)] focus-ring rounded px-2 py-1">
              (203) 872-9965
            </Link>
            <span className="hidden sm:inline text-foreground-dark/40">•</span>
            <Link to="mailto:info@carserviceconnecticut.com" className="hover:text-accent transition-colors duration-[var(--duration-fast)] focus-ring rounded px-2 py-1">
              info@carserviceconnecticut.com
            </Link>
          </div>
        </div>
      </div>
    </section>;
}